const USERS = [
    { id: 'web-alex', firstName: 'Алекс', lastName: 'Игров', platform: 'web' },
    { id: 'web-maria', firstName: 'Мария', lastName: 'Блокова', platform: 'web' },
];
export class WebPlatformAdapter {
    platform = 'web';
    backListeners = new Set();
    async initialize() {
        if (!['localhost', '127.0.0.1'].includes(window.location.hostname)) {
            throw new Error('Development web adapter is disabled outside localhost');
        }
        window.addEventListener('popstate', () => this.backListeners.forEach((listener) => listener()));
    }
    async getLaunchData() {
        const params = new URLSearchParams(window.location.search);
        return {
            raw: params.toString(),
            startParameter: params.get('start'),
            source: 'web-development',
        };
    }
    async getCurrentUser() {
        const requested = new URLSearchParams(window.location.search).get('user');
        const known = USERS.find((user) => user.id === requested);
        if (known)
            return known;
        if (requested && requested.length <= 100 && /^[a-zA-Z0-9_-]+$/.test(requested))
            return {
                id: requested,
                firstName: 'Тестовый игрок',
                lastName: requested.slice(-6),
                platform: 'web',
            };
        return USERS[0];
    }
    getStartParameter() {
        return new URLSearchParams(window.location.search).get('start');
    }
    async share(payload) {
        if (navigator.share) {
            await navigator.share({ text: payload.text, url: payload.url });
            return { shared: true, method: 'native' };
        }
        await navigator.clipboard.writeText(`${payload.text} ${payload.url}`);
        return { shared: true, method: 'clipboard' };
    }
    async openExternal(url) {
        window.open(url, '_blank', 'noopener,noreferrer');
    }
    async joinCommunity(url) {
        await this.openExternal(url);
        return true;
    }
    async requestNotifications() {
        if (!('Notification' in window))
            return false;
        return (await Notification.requestPermission()) === 'granted';
    }
    async haptic(type) {
        const pattern = {
            light: 12,
            medium: 22,
            heavy: 38,
            success: [16, 42, 26],
            error: [32, 35, 32],
        };
        navigator.vibrate?.(pattern[type]);
    }
    showBackButton() { }
    hideBackButton() { }
    onBack(callback) {
        this.backListeners.add(callback);
        return () => this.backListeners.delete(callback);
    }
    async getViewport() {
        return { width: window.innerWidth, height: window.innerHeight, stable: true };
    }
    async purchaseProduct(productId) {
        return { completed: true, transactionId: `web-${productId}-${Date.now()}` };
    }
}
